<template>
  <div id="app">
    <router-view ></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        flag:true,
        form:{
          id:''
        },
        instance:''
      };
    },
    mounted() {
        if(this.getCookie('userInfo')){
          this.msgInit();
        }
    },
    methods:{
      msgInit(){
        this.Axios({
            url:Action.SYSTEM_NOTICE_UNREAD,
            method:'post',
            headers:{
              'Authorization':JSON.parse(this.getCookie('userInfo')).tokenType+ ' ' +JSON.parse(this.getCookie('userInfo')).accessToken 
              },
            data:{}
        }).then((res) => {
            var res = res.data;
            if(res.code === '000'){
                if(res.result){
                  if(res.result.id==this.form.id){

                  }else{
                    this.flag = true;
                    this.form = res.result;
                    this.openMsg();
                  }
                  
                }
            }else{
              this.$alert(res.msg || '操作频繁，请稍后再试.','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
            }
        }).catch((err) => {
            console.log(err);
            this.$alert(err.data.msg || '操作频繁，请稍后再试.','错误提示',{
                cofirmButtonText:'确定',
                type:'error'
            })
        })
      },
      openMsg(){
        if(this.flag){
          this.instance = this.$notify({
            title: this.form.title,
            dangerouslyUseHTMLString: true,
            message: '<div @click="test" class="line_5">'+this.form.mainBody+'</div>',
            onClick:this.test,
            position: 'bottom-right',
            duration: 0,
            offset: 40
          });
          this.flag = false
        }
        
      },
      test(){
        this.$router.push({path:'/ywcollectNews',query:{id:this.form.id,info:this.form.id}})
        this.instance.close()
      }
    },
    watch: {
    '$route': function () {
        if(this.getCookie('userInfo')){
          this.msgInit();
        }
        return false;
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #657180;
  }
  .el-table thead th .cell, .el-table thead.is-group th{
    background:#0d7778 !important;
    color: #fff;
  }
  .el-table thead th{
     background:#0d7778 !important;
  }
  .el-pager li.active, .el-pager li:hover{
    background:#0d7778 !important;
    border-color:#0d7778 !important;
  }
    .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  /* .el-button--greenw_f, .el-button--greenw_f:focus, .el-button--greenw_f:hover{
    color:#0d7778 !important;
    
     border-color: #0d7778 !important;
  } */
  .line_5{
    width: 300px;
    cursor: pointer;
  }
  .line_5 div,.line_5 h1,.line_5 h2,.line_5 h3,.line_5 h4,.line_5 h5,.line_5 h6,.line_5 b,.line_5 i,.line_5 u,.line_5 strike,.line_5 sub,.line_5 sup{
    display: none;
  }
  .line_5 div:first-child,.line_5 h1:first-child,.line_5 h2:first-child,.line_5 h3:first-child,.line_5 h4:first-child,.line_5 h5:first-child,.line_5 h6:first-child,.line_5 b:first-child,.line_5 i:first-child,.line_5 u:first-child,.line_5 strike:first-child,.line_5 sub:first-child,.line_5 sup:first-child{
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  } 
</style>



// WEBPACK FOOTER //
// src/App.vue